import { useState } from 'react';

const faqs = [
  {
    q: '¿Es pago único o mensual?',
    a: 'Es un pago anual de solo $12. Sin cargos mensuales ocultos ni sorpresas. Pagas una vez al año y tienes acceso completo a ambos sistemas + bonos.',
  },
  {
    q: '¿Necesito saber de tecnología?',
    a: 'Para nada. Ambos sistemas están diseñados para ser intuitivos y fáciles de usar. Si sabes usar un celular, puedes usar Stock Simple y Budgettrack sin problema.',
  },
  {
    q: '¿Es seguro?',
    a: 'Sí, 100%. Tus datos están encriptados y alojados en servidores seguros en la nube. Nunca compartimos tu información con terceros.',
  },
  {
    q: '¿Cómo accedo?',
    a: 'Tras completar el pago recibes acceso inmediato por correo electrónico. En menos de 5 minutos ya puedes estar usando los sistemas.',
  },
  {
    q: '¿Desde qué dispositivos puedo usarlo?',
    a: 'Desde cualquier dispositivo con conexión a internet: celular, tablet, laptop o computadora de escritorio. Todo sincronizado en tiempo real.',
  },
  {
    q: '¿Los programas tienen Inteligencia Artificial?',
    a: 'Sí. Ambos sistemas cuentan con IA integrada que analiza tu inventario, detecta fugas de dinero y te da recomendaciones personalizadas en segundos.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="bg-[#0a0a0a] py-20 md:py-28 px-6">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest">Resolvemos tus dudas</span>
          <h2 className="text-3xl md:text-4xl font-black text-white mt-3">¿Aún tienes dudas?</h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`bg-[#111] rounded-xl overflow-hidden border transition-all duration-300 ${openIndex === i ? 'border-[#00FF88]/30' : 'border-white/5 hover:border-white/15'}`}
            >
              <button
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="text-white font-bold text-base md:text-lg pr-4">{faq.q}</span>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`text-2xl transition-all duration-300 ${openIndex === i ? 'ri-subtract-line text-[#00FF88]' : 'ri-add-line text-[#00FF88]'}`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-6 pb-6">
                  <p className="text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
